import { QueryHookOptions } from '@apollo/client';

import type { EstateOnboardingSuggestion } from '@/modules/aiSuggestions/aiSuggestions.contracts';
import { getNodes } from '@/utils/graphqlUtils';

import {
  EstateOnboardingUnacknowledgedSuggestionsV2Query,
  EstateOnboardingUnacknowledgedSuggestionsV2QueryVariables,
  useEstateOnboardingUnacknowledgedSuggestionsV2Query,
} from '../graphql/EstateOnboardingUnacknowledgedSuggestionsV2.generated';

type QueryOptions = Omit<
  QueryHookOptions<
    EstateOnboardingUnacknowledgedSuggestionsV2Query,
    EstateOnboardingUnacknowledgedSuggestionsV2QueryVariables
  >,
  'variables'
>;

interface UseFetchEstateOnboardingSuggestionsOptions {
  householdId: string | undefined | null;
  skip?: boolean;
  onError?: QueryOptions['onError'];
  onCompleted?: QueryOptions['onCompleted'];
}

export function useFetchEstateOnboardingSuggestions({
  householdId,
  skip,
  onError,
  onCompleted,
}: UseFetchEstateOnboardingSuggestionsOptions) {
  return useEstateOnboardingUnacknowledgedSuggestionsV2Query({
    skip: skip || !householdId,
    variables: {
      householdID: householdId!,
    },
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'cache-and-network',
    onError,
    onCompleted,
  });
}

export function processEstateOnboardingSuggestionsDataV2(
  data: EstateOnboardingUnacknowledgedSuggestionsV2Query
): EstateOnboardingSuggestion[] {
  return getNodes(data.aiSuggestions) as EstateOnboardingSuggestion[];
}
